// extracted by mini-css-extract-plugin
export default {"geoCheckbox":"ItemEditPanel_geoCheckbox__DXpnG","panelBottom":"ItemEditPanel_panelBottom__YQ1e4"};